export default __webpack_public_path__ + "a9ca7bdf836fbcb466829934fe6b1d5d.png";